function AccessNothingController(userService) {
    const ctrl = this;

    ctrl.logOut = () => {
        userService.logout();
    };
}

angular
    .module('access-nothing.module')
    .controller('AccessNothingController', AccessNothingController);
